// EditCompany.js
import React, { useEffect, useState } from 'react';
import Navbar from '../../Navbar';
import Sidebar from '../../Sidebar';
import { Link, useNavigate, useParams } from 'react-router-dom'; // Import useParams
import {  BASE_URL, TOKEN } from '../../commonConstants'; 

const EditCompany = ({ userName, role, onLogout }) => {
    const navigate = useNavigate();
    const { id } = useParams(); // Get the id parameter from the URL

    const [success, setSuccess] = useState(false);
	const [error, setError] = useState(null);
    const [info, setInfo] = useState(false);	
	const [companyNameError, setCompanyNameError] = useState('');
	const [websiteError, setWebsiteError] = useState('');
	const [commissionError, setCommissionError] = useState('');    
    const [initialPartnerData, setInitialPartnerData] = useState(null);
    const [agreementError, setAgreementError] = useState('');
	const [signedDateError, setSignedDateError] = useState('');
	const [onBoardedDateError, setOnBoardedDateError] = useState('');
	const [fadeOut, setFadeOut] = useState(false);
    const [typeError, setTypeError] = useState('');


	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]); // Define state variable to hold data


    const [partnerData, setPartnerData] = useState({       
        company_name: '',
        website: '',
        commission_percentage: '',      
        created_at: '',       
        agreement_from: '',
        signed_date: '',
        onboarded_on: ''
    });

    // Dynamic options for status select
    let statusOptions = [
        { value: 'active', label: 'Active' },
        { value: 'suspended', label: 'Block' },
        { value: 'pending', label: 'Pending'},
    ];
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${BASE_URL}companies/${id}`, { // Use the id parameter in the URL
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${TOKEN}`,
                    }                  
                });
                if (!response.ok) {
                    navigate(`/companies/`);
                    throw new Error('Failed to fetch partner');
                }
                const responseData = await response.json();
                setPartnerData(responseData.data); 
                setInitialPartnerData(responseData.data); // Set the initial state
                setLoading(false);
            } catch (error) {
                // console.error('Error fetching users:', error);
                setError('Failed to fetch users');               
                setLoading(false);
            }
            window.scrollTo(0, 0);
        };

        fetchData();
    }, [id]); 

    useEffect(() => {
		let hideTimeout;
		let removeTimeout;
	
		if (success || error || info) {
		  // Start fading out before removing
		  hideTimeout = setTimeout(() => {
			setFadeOut(true);
		  }, 2000); // Start fading out 0.5 seconds before removing
	
		  // Remove the alert after the fade-out transition
		  removeTimeout = setTimeout(() => {
			setSuccess(null);
			setError(null);
			setFadeOut(false); // Reset fadeOut for future alerts
		  }, 5000); // Remove after 2 seconds
		}
	
		return () => {
		  clearTimeout(hideTimeout);
		  clearTimeout(removeTimeout);
		};
	  }, [success, error, info]);

    const updatePartner = async () => {
        if (!validateForm()) {
            return;
          }
          if (JSON.stringify(partnerData) === JSON.stringify(initialPartnerData)) {
            // If they are the same, don't make the API call
            // console.log('No changes were made');
            setInfo('No changes were made');
            window.scrollTo(0, 0);
            setSuccess('');
            setError('');
		    return;
        } else { setInfo(''); setInitialPartnerData(partnerData); }
        try {
            const response = await fetch(`${BASE_URL}companies/${id}`, { 
                method: 'PUT', // Use PUT method for updating
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${TOKEN}`,
                },
                body: JSON.stringify(partnerData), // Send updated data in the request body
            });
			const responseData = await response.json();
            if (response.ok) {
				setError('');
				setSuccess('Partner Updated successfully');
			} else {
                setSuccess('');
				// Handle login error (e.g., display error message)				
					setError('Error updating partner ', error);
			}
            // Optionally, you can handle success (e.g., show a success message or navigate to another page)
            // console.log('Partner updated successfully');
        } catch (error) {
            setError('Error updating partner:', error);
            // console.error('Error updating partner:', error);
            // Optionally, you can set an error state to display an error message to the user
        }
        window.scrollTo(0, 0);
    };
    // Handler for updating partner status
    const handleStatusChange = (e) => {
        setPartnerData({ ...partnerData, status: e.target.value });
    };
  
    const validateForm = () => {
		let isValid = true;		

		if (!partnerData.company_name) {			
			setCompanyNameError('Company name is required');
			isValid = false;
		} else {
			setCompanyNameError('');
		}
		if (!partnerData.website) {			
			setWebsiteError('Website is required');
			isValid = false;
		} else {
			setWebsiteError('');
		}
		if(!partnerData.commission_percentage){
			setCommissionError('Commission percentage is required');
			isValid = false;
		}
		else if (isNaN(partnerData.commission_percentage) || partnerData.commission_percentage < 0 || partnerData.commission_percentage > 100) {
			setCommissionError('Commission percentage must be a number within 0 and 100');
			isValid = false;
		} else {
			setCommissionError('');
		}
		if(!partnerData.agreement_from){
			setAgreementError('Agreement from date is required');
			isValid = false;
		} else {
			setAgreementError('');
		}
		if(!partnerData.signed_date){
			setSignedDateError('Signed date is required');
			isValid = false;
		} else {
			setSignedDateError('');
		}
		if(!partnerData.onboarded_on){
			setOnBoardedDateError('Onboarded date is required');
			isValid = false;
		} else {
			setOnBoardedDateError('');
		}    
		return isValid;
	};
	
	const isValidEmail = (email) => {
		const re = /\S+@\S+\.\S+/;
		return re.test(email);
	};
    if (partnerData.email_verified_at === null) {
    statusOptions = statusOptions.filter(option => option.value !== 'active');
    }


    return (
        <div className="sb-nav-fixed">
            <Navbar userName={userName} role={role} onLogout={onLogout} />
            <div id="layoutSidenav">
                <Sidebar role={role} onLogout={onLogout} page="companies"/>
                <div id="layoutSidenav_content">
                <main>
                        <div className="container-fluid position-relative px-4">
                       
                        {success && <div className= { `position-absolute start-50 translate-middle-x w-25 m-auto py-2 alert alert-success alert-dismissible  mb-0 fade show${fadeOut ? 'alert-fade-out' : ''}`} role="alert">{success}<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() =>setSuccess(null)}></button></div>}
                        {error && <div className= { `position-absolute start-50 translate-middle-x w-25 m-auto py-2 alert alert-danger alert-dismissible mb-0 fade show${fadeOut ? 'alert-fade-out' : ''}`} role="alert">{error}<button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close" onClick={() =>setError(null)}></button></div>}
                            {info && <div className= { `position-absolute start-50 translate-middle-x w-25 m-auto py-2 alert alert-info alert-dismissible mb-0 fade show${fadeOut ? 'alert-fade-out' : ''}`} role="alert">{info}<button type="button" className="btn-close" data-bs-dismiss="alert" onClick={() => setInfo(null)}  aria-label="Close"></button></div>}

                            <div className="row align-items-center justify-content-center">
                                <div className="col-md-12">
                                    <h1 className="fs-4 mb-0">Edit Company</h1>
                                </div>
                            </div>
                            <form className="p-4 shadow-sm border my-4" onSubmit={(e) => { e.preventDefault(); updatePartner(); }}>
                                
                                <div className="row mb-4">
                                    
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input className={`form-control ${companyNameError ? 'is-invalid' : ''}`} id="inputCompany" type="text" placeholder="Enter your company name" value={partnerData.company_name} onChange={(e) =>{ setPartnerData({ ...partnerData, company_name: e.target.value }); setCompanyNameError(e.target.value.trim() === '' ? 'Company name is required' : ''); }} />
                                            <label htmlFor="inputCompany">Company</label>
                                            {companyNameError && <div className="invalid-feedback">{companyNameError}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                    <div className="form-floating">
                                        <input className={`form-control ${websiteError ? 'is-invalid' : ''}`} id="inputWebsite" type="text" placeholder="Enter your website" value={partnerData.website} onChange={(e) =>{ setPartnerData({ ...partnerData, website: e.target.value }); setWebsiteError(e.target.value.trim() === '' ? 'Website is required' :''); }} />
                                        <label htmlFor="inputWebsite">Website</label>
                                        {websiteError && <div className="invalid-feedback">{websiteError}</div>}
                                    </div>
                                    </div>
                                </div>
                                <div className="row mb-4">                                   
                                   
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input className={`form-control ${agreementError ? 'is-invalid' : ''}`} id="inputType" type="date" placeholder="Enter Agreement From" value={partnerData.agreement_from|| ''} onChange={(e) =>{ setPartnerData({ ...partnerData, agreement_from: e.target.value }); setAgreementError(e.target.value.trim() == '' ? ' is required' :''); }} />
                                            <label htmlFor="inputType"> Agreement From</label>
                                            {agreementError && <div className="invalid-feedback">{agreementError}</div>}
                                        </div>
                                    </div>
                                    <div className='col-md-6'>
                                        <div className="form-floating">
                                            <input className={`form-control ${commissionError ? 'is-invalid' : ''}`} id="inputCommission" type="text" placeholder="Enter commission" value={partnerData.commission_percentage} onChange={(e) =>{ setPartnerData({ ...partnerData, commission_percentage: e.target.value }); setCommissionError(e.target.value.trim() == '' ? 'Commision Percentage is required' :''); }} />
                                            <label htmlFor="inputCommission">Commission (%)</label>
                                            {commissionError && <div className="invalid-feedback">{commissionError}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row mb-4">                                    
                                <div className="col-md-6">
                                        <div className="form-floating">
                                            <input className={`form-control ${signedDateError ? 'is-invalid' : ''}`} id="inputSigned" type="date" placeholder="Enter Signed date" value={partnerData.signed_date|| ''} onChange={(e) =>{ setPartnerData({ ...partnerData, signed_date: e.target.value }); setSignedDateError(e.target.value.trim() == '' ? 'Signed Date is required' :''); }} />
                                            <label htmlFor="inputSigned"> Signed Date</label>
                                            {signedDateError && <div className="invalid-feedback">{signedDateError}</div>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <input className={`form-control ${onBoardedDateError ? 'is-invalid' : ''}`} id="inputOnboarded" type="date" placeholder="Enter Onboarded date" value={partnerData.onboarded_on|| ''} onChange={(e) =>{ setPartnerData({ ...partnerData, onboarded_on: e.target.value }); setOnBoardedDateError(e.target.value.trim() == '' ? ' Onboarded date is required' :''); }} />
                                            <label htmlFor="inputOnboarded">Onboarded On</label>
                                            {onBoardedDateError && <div className="invalid-feedback">{onBoardedDateError}</div>}
                                        </div>
                                    </div>
                                </div>

                                <div className="row mb-4">
                                    <div className="col-md-6">
                                        <div className="form-floating">
                                            <select className="form-select" id="inputType" value={partnerData.type || ''} onChange={(e) => { setPartnerData({ ...partnerData, type: e.target.value }); setTypeError(e.target.value.trim() === '' ? 'Partner Type is required' : ''); }}>
                                                <option value="" disabled>Select Partner Type</option>
                                                <option value="channel">Channel</option>
                                                <option value="referral">Referral</option>
                                            </select>
                                            <label htmlFor="inputType">Patner Type</label>
                                            {typeError && <div className="invalid-feedback">{typeError}</div>}
                                        </div>
                                    </div>                                   
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-floating">                                           
                                        <span>Created Date : </span>{(partnerData.created_at_formated) || ''}
                                        </div>
                                    </div>                                    
                                </div>
                                    <div className="row mb-4">
                                    <div className="col-md-12 text-end">
                                        <Link className="btn btn-link text-decoration-none" aria-current="page" to="/partners">Cancel</Link>
                                        <button type="submit" className="btn btn-primary mx-2">Update</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default EditCompany;
